export default "__VITE_ASSET__539177e4__"